import { Component } from '@angular/core';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-suggestion-box-page',
  templateUrl: './suggestion-box-page.component.html',
  standalone: false,
})
export class SuggestionBoxPageComponent extends BasePage {}
